<template>
  <div class="period">
    <el-card>
      <el-radio-group v-if="isShow" v-model="filter.belongCompanyId" size="small" @change="getRefundPeriodStatistics">
        <el-radio-button label="">集团数据</el-radio-button>
        <el-radio-button v-for="item in companyList" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
        <el-radio-button :label="100">中英考研</el-radio-button>
        <el-radio-button :label="400">神啦考研</el-radio-button>
      </el-radio-group>
      <div style="margin-top: 10px">
        订单支付时间: <myDatePicker :dateInit="setDate"
                            @sendMyDate="receiveMyDate"></myDatePicker>
        <div class="fr">
          <el-select size="small" v-model="filter.type" @change="getRefundPeriodStatistics">
            <el-option :value="1" label="阶段数据"></el-option>
            <el-option :value="2" label="累计数据"></el-option>
          </el-select>
          <el-button type="primary" size="small" style="margin-left: 10px;" @click="getRefundPeriodStatistics">刷新</el-button>
        </div>
      </div>
      <div style="margin-top: 10px" ref="echarts" class="echarts" v-loading="loading"></div>
      <el-table :data="tableList" border>
        <el-table-column align="center" label="事业部" prop="belongCompanyName"></el-table-column>
        <el-table-column align="center" label="成单数量" prop="num"></el-table-column>
        <el-table-column v-for="item in xConfig" :key="item.name" align="center" :label="item.name">
          <template slot-scope="scope">
            <span v-if="scope.row[item.key]">{{ scope.row[item.key.split('Rate').join('Num') || 0] }} | {{ scope.row[item.key] + '%' }}</span>
            <span v-else>0 | 0%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import dayjs from 'dayjs'

import { getAvailableCompanyList, getRefundPeriodStatistics } from '@/api/refund'
import myDatePicker from './components/myDatePicker'
export default {
  name: 'Period',
  components: { myDatePicker },
  data () {
    return {
      myCharts: null,
      loading: false,
      companyList: [],
      filter: {
        type: 1,
        belongCompanyId: '',
        startDate: dayjs(dayjs()).startOf('month').format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD')
      },
      tableList: [],
      xConfig: [
        {
          name: '当日退费',
          key: 'oneRefundRate',
          type: 1
        },
        {
          name: '次日退费',
          key: 'twoRefundRate',
          type: 1
        },
        {
          name: '3~7日退费',
          key: 'threeRefundRate',
          type: 1
        },
        {
          name: '8~15日退费',
          key: 'fourRefundRate',
          type: 1
        },
        {
          name: '16~30日退费',
          key: 'fiveRefundRate',
          type: 1
        },
        {
          name: '31~60日退费',
          key: 'sixRefundRate',
          type: 1
        },
        {
          name: '61~90日退费',
          key: 'sevenRefundRate',
          type: 1
        },
        {
          name: '91~180日退费',
          key: 'eightRefundRate',
          type: 1
        },
        {
          name: '181~365日退费',
          key: 'nineRefundRate',
          type: 1
        },
        {
          name: '366日以上退费',
          key: 'tenRefundRate',
          type: 1
        },
      ],
      isShow: true
    }
  },
  computed: {
    setDate: {
      get () {
        return [this.filter.startDate, this.filter.endDate]
      },
      set (val) {
        if (val && val.length) {
          this.filter.startDate = val[0]
          this.filter.endDate = val[1]
        }
      }
    }
  },
  created() {
    if (this.$myStore.state.user.userInfo.companyId !== '1') {
      this.filter.belongCompanyId = this.$myStore.state.user.userInfo.companyId
      this.isShow = false
    }
    this.getAvailableCompanyList()
    this.getRefundPeriodStatistics()
  },
  methods: {
    receiveMyDate (date) {
      this.setDate = date
      this.getRefundPeriodStatistics()
    },
    async getAvailableCompanyList () {
      const res = await getAvailableCompanyList()
      this.companyList = res.data
    },
    async getRefundPeriodStatistics() {
      this.loading = true
      const res = await getRefundPeriodStatistics(this.filter)
      this.tableList = res.data
      const legend = []
      const xConfig = this.xConfig.filter(item => item.type === 1)
      const xAxis = xConfig.map(item => {
        return item.name
      })
      const series = []
      this.tableList.forEach(item => {
        legend.push(item.belongCompanyName)
        series.push({
          name: item.belongCompanyName,
          type: 'line',
          smooth: true,
          data: xConfig.map(col => {
            return item[col.key] || 0
          })
        })
      })
      if (!this.myCharts) this.myCharts = echarts.init(this.$refs.echarts)
      this.myCharts.clear()
      this.myCharts.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const title = params[0] ? params[0].axisValueLabel : '--'
            const newParams = []
            let paramsData = params.sort((a, b) => {
              return b.value - a.value
            })
            paramsData.forEach((p) => {
              // p.marker为对应数据线的颜色的圆点
              // p.seriesName为对应数据的数据名称
              // p.value为对应数据的值
              let value = 0
              if (p.value) {
                value = p.value.toLocaleString()
              }
              const cont = p.marker + ' ' + p.seriesName + ': ' + value + '%' + '<br/>'
              newParams.push(cont)
            })
            return `${title}<br>${newParams.join('')}`
          }
        },
        legend: {
          data: legend
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        },
        yAxis: {
          type: 'value',
          // min: 0,
          // max: 100,
          axisLabel: {
            formatter: function (value, index) {
              return value + "%";
            }
          }
        },
        series,
        color: ['#7E80FF', '#81CEFF', '#28CC9E', '#FA5555', '#FFB400', '#AC73FF', '#4678EB', '#B3B3B3', '#FFABE5', '#7BCECC', '#333333', '#EFD510', '#D1F4FA', '#9BDF46', '#F25292', '#273F9D', '#ACA8FF', '#3090A1', '#FFFFFF', '#FFF5A5']
      })
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.period {
  .echarts {
    height: 500px;
  }
  .fr {
    float: right;
  }
}
</style>
